import React from 'react';

const AmountInput = ({ value, onChange, placeholder, className, required, ...props }) => {
  const handleChange = (e) => {
    // Remove all non-digits
    const raw = e.target.value.replace(/[^0-9]/g, '');
    onChange({ target: { name: e.target.name, value: raw } });
  };

  const formatDisplay = (val) => {
    if (!val) return '';
    return Number(val).toLocaleString('en');
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={formatDisplay(value)}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      required={required}
      {...props}
    />
  );
};

export default AmountInput;
